// Pipeline Section (Statement of Work)
export const FETCH_SHIPMENT_TYPE_DETAILS = '@@fetch-shipment-type-details';
export const FETCH_SHIPMENT_TYPE_DETAILS_SUCCESS = '@@fetch-shipment-type-details-success';
export const FETCH_SHIPMENT_TYPE_DETAILS_FAILURE = '@@fetch-shipment-type-details-failure';
export const FETCH_SHIPMENTS = '@@fetch-shipments';
